var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-wrapper"},[(_vm.$route.name !== 'KundeKontraktObjektFullscreen')?_c('header',[_c('MainToolbar'),_vm._v(" "),_c('MainNavigation')],1):_vm._e(),_vm._v(" "),_c('main',[_c('router-view'),_vm._v(" "),_c('span',{staticClass:"nav-close"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4099fa24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/AdminLayout.vue
// module id = null
// module chunks = 